import React, { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

interface FestiveContextType {
    isFestiveEnabled: boolean;
    toggleFestive: () => void;
}

const FestiveContext = createContext<FestiveContextType | undefined>(undefined);

export const FestiveProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isFestiveEnabled, setIsFestiveEnabled] = useState<boolean>(false);

    useEffect(() => {
        localStorage.setItem('festive-enabled', JSON.stringify(isFestiveEnabled));
    }, [isFestiveEnabled]);

    const toggleFestive = () => {
        setIsFestiveEnabled(prev => !prev);
    };

    return (
        <FestiveContext.Provider value={{ isFestiveEnabled, toggleFestive }}>
            {children}
        </FestiveContext.Provider>
    );
};

export const useFestive = (): FestiveContextType => {
    const context = useContext(FestiveContext);
    if (context === undefined) {
        throw new Error('useFestive must be used within a FestiveProvider');
    }
    return context;
};
